export * from './buttons/buttons.component';
export * from './button/button.component';
export * from './search/search.component';
export * from './tabs/tabs.component';
export * from './table/table.component';
export * from './input/input.component';
export * from './num/num.component';
export * from './inputButton/inputButton.component';
export * from './interest/interest.component';
export * from './textarea/textarea.component';
export * from './modal/modal.component';
export * from './summary/summary.component';
export * from './article/article.component';
export * from './service/service.component';
export * from './postit/postit.component';
export * from './sms/sms.component';
export * from './socketSms/socketSms.component'
export * from './tel/tel.component';
export * from './letter/letter.component';
export * from './bikeModal/bikeModal.component';
export * from './order/order.component';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/index.ts